import { createAsyncAction } from "../../helpers/actions"
import { buildSuccessMeta } from "../../notifications/operators/successMetaBuilder"
import { putProfile } from "../api/putProfile"
import { SAVE_PROFILE } from "../constants/ActionTypes"

export const saveProfile = createAsyncAction(SAVE_PROFILE, putProfile, {
  successMetaCreator: buildSuccessMeta("Saved profile successfully"),
})
